import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=4e98d3a4&"
import script from "./Judge.vue?vue&type=script&lang=js&"
export * from "./Judge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports